import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import SliderComponent from "./sliderComponent.js"
import { buildYearLabel, yearDefault } from "../moreFiltersContainer/yearsFilterConfig"

class YearInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentRange: this.props.currentRange,
      labelRange: this.props.currentRange
    }
  }

  componentDidMount() {
    //we might grab the URL here on mount. but I don't know if we should or not.
    //might pass these down as defaultValue props.
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentRange !== this.props.currentRange) {
      if (this.props.currentRange !== this.state.currentRange) {
        this.setState({
          currentRange: this.props.currentRange,
          labelRange: this.props.currentRange
        })
      }
    }
  }

  handleLabelChange = values => {
    this.setState({
      labelRange: values
    })
  }

  handleYearChange = values => {
    this.setState({
      currentRange: values
    })
    this.props.onChange(values)
  }

  render() {
    const { currentRange, labelRange } = this.state

    const { showFeedbackLabel, defaultMax, defaultMin } = this.props


    return (
      <React.Fragment>
        {showFeedbackLabel && (
          <div className="slider-label">
            {buildYearLabel(labelRange)}
          </div>
        )}
        <SliderComponent
          domain={[defaultMin, defaultMax]}
          currValues={currentRange}
          onUpdate={this.handleLabelChange}
          steps={1}
          onSlideEnd={this.handleYearChange}
        />
      </React.Fragment>
    )
  }
}

export default withRouter(YearInput)

YearInput.defaultProps = {
  showFeedbackLabel: true,
  defaultMin: yearDefault[0],
  defaultMax: yearDefault[1],
  defaultLabel: "Price",
  currentRange: [yearDefault[0], yearDefault[1]],
  onChange: function() {}
}
